import { urlStudents } from '../../api/urls';
import {
  apiGet,
  apiPost,
  apiDelete,
  apiDownloadPost,
} from '../../api/index';

export function fetchStudents(params) {
  const pageInfo = params && params.pageInfo
    ? params.pageInfo
    : { page: 1, pageSize: 15 };
  return apiPost(`${urlStudents}/all`, pageInfo)
    .then((res) => {
      if (res.error) {
        throw (res.error);
      }
      if (params && params.onSuccess) params.onSuccess(res);
      return res;
    })
    .catch((error) => {
      if (params && params.onError) params.onError(error);
    });
}

export function reporteInscriptos(params) {
  const pageInfo = params && params.pageInfo
    ? params.pageInfo
    : { page: 1, pageSize: 15 };
  return apiPost(`${urlStudents}/reporte_inscriptos`, pageInfo)
    .then((res) => {
      if (res.error) {
        throw (res.error);
      }
      if (params && params.onSuccess) params.onSuccess(res);
      return res;
    })
    .catch((error) => {
      if (params && params.onError) params.onError(error);
    });
}


export function reporteAlumnosFormData(params) {
  return apiGet(`${urlStudents}/reporte_alumnos`)
    .then((res) => {
      if (res.error) {
        throw (res.error);
      }
      if (params && params.onSuccess) params.onSuccess(res);
      return res;
    })
    .catch((error) => {
      if (params && params.onError) params.onError(error);
    });
}

export function reporteAlumnos(params) {
  const pageInfo = params && params.pageInfo
    ? params.pageInfo
    : { page: 1, pageSize: 15 };
  return apiPost(`${urlStudents}/reporte_alumnos`, pageInfo)
    .then((res) => {
      if (res.error) {
        throw (res.error);
      }
      if (params && params.onSuccess) params.onSuccess(res);
      return res;
    })
    .catch((error) => {
      if (params && params.onError) params.onError(error);
    });
}

export function reporteAcademicStatusStudent(id = '', params) {
  return apiGet(`${urlStudents}/reporte-academic-status-student/${id}`)
    .then((res) => {
      if (res.error) {
        throw (res.error);
      }
      if (params && params.onSuccess) params.onSuccess(res);
      return res;
    })
    .catch((error) => {
      if (params && params.onError) params.onError(error);
    });
}

export function downloadAcademicStatusStudent(id = '', params) {
  return apiDownloadPost(`${urlStudents}/download-reporte-academic-status-student/${id}`)
    .then((blob) => {
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = 'Reporte Estado Academico.xlsx';
      document.body.appendChild(link);
      link.click();
      link.remove();
      if (params && params.onSuccess) params.onSuccess(blob);
    })
    .catch((error) => {
      if (params && params.onError) params.onError(error);
    });
}

export function downloadStudents(params) {
  const filters = params.filters || {};
  return apiDownloadPost(`${urlStudents}/reporte_alumnos_download`, filters)
    .then((blob) => {
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = 'Alumnos.xlsx';
      document.body.appendChild(link);
      link.click();
      link.remove();
      if (params && params.onSuccess) params.onSuccess(blob);
    })
    .catch((error) => {
      if (params && params.onError) params.onError(error);
    });
}

export function downloadStudentsInscriptos(params) {
  const filters = params.filters || {};
  return apiDownloadPost(`${urlStudents}/reporte_inscriptos_download`, filters)
    .then((blob) => {
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = 'Alumnos-Inscriptos.xlsx';
      document.body.appendChild(link);
      link.click();
      link.remove();
      if (params && params.onSuccess) params.onSuccess(blob);
    })
    .catch((error) => {
      if (params && params.onError) params.onError(error);
    });
}

export function fetchSelectStudentValues(callback) {
  return apiGet(`${urlStudents}/select_values`)
    .then((res) => {
      if (res.error) {
        throw (res.error);
      }
      if (callback && callback.onSuccess) callback.onSuccess(res);
      return res;
    })
    .catch((error) => {
      if (callback && callback.onError) callback.onError(error);
    });
}

export function fetchSelectStudentValuesPorCarrera(idCarrera, callback) {
  return apiGet(`${urlStudents}/select_values_por_carrera/${idCarrera}`)
    .then((res) => {
      if (res.error) {
        throw (res.error);
      }
      if (callback && callback.onSuccess) callback.onSuccess(res);
      return res;
    })
    .catch((error) => {
      if (callback && callback.onError) callback.onError(error);
    });
}


export function fetchStudent(id, callback) {
  return apiGet(`${urlStudents}/${id}`)
    .then((res) => {
      if (res.error) {
        throw (res.error);
      }
      if (callback && callback.onSuccess) callback.onSuccess(res);
      return res;
    })
    .catch((error) => {
      if (callback && callback.onError) callback.onError(error);
    });
}

export function saveStudent(user, callback) {
  return apiPost(`${urlStudents}`, user)
    .then((res) => {
      if (res.error) {
        throw (res.error);
      }
      if (callback && callback.onSuccess) callback.onSuccess(res);
      return res;
    })
    .catch((error) => {
      if (callback && callback.onError) callback.onError(error);
    });
}

export function deleteStudent(id, callback) {
  return apiDelete(`${urlStudents}/${id}`)
    .then((res) => {
      if (res.error) {
        throw (res.error);
      }
      if (callback && callback.onSuccess) callback.onSuccess(res);
      return res;
    })
    .catch((error) => {
      if (callback && callback.onError) callback.onError(error);
    });
}

export function fetchAllMallas(params) {
  return apiGet(`${urlStudents}/mallas`)
    .then((res) => {
      if (res.error) {
        throw (res.error);
      }
      if (params && params.onSuccess) params.onSuccess(res);
      return res;
    })
    .catch((error) => {
      if (params && params.onError) params.onError(error);
    });
}
